import React from 'react';

import * as styles from './styles';

import { type DateRange, type EventSeverity, EventTrigger, Severity, type UUID } from '@cobliteam/common-types';

import TagFeatures from '@cobliteam/ui-business/components/Tag/Features';
import TagGravity from '@cobliteam/ui-business/components/Tag/Gravity';

interface SeverityTagProps {
  severity: Severity;
  mediaPeriod?: DateRange;
  vehicleIds?: UUID[];
  driverIds?: UUID[];
  eventTriggers?: EventTrigger[];
  severities?: EventSeverity[];
  isFavorite?: boolean;
}

export const getMediaEventLabel = (eventTrigger: EventTrigger) => {
  switch (eventTrigger) {
    case EventTrigger.HARSH_BREAKING:
      return 'Frenagem brusca';
    case EventTrigger.HARSH_ACCELERATION:
      return 'Aceleração brusca';
    case EventTrigger.HARSH_CORNERING:
      return 'Curva brusca';
    case EventTrigger.COLLISION:
      return 'Impacto e trepidação';
    case EventTrigger.TRAFFIC_SPEED_VIOLATED:
      return 'Velocidade da via excedida';
    case EventTrigger.STOP_SIGN_VIOLATED:
      return 'Placa de PARE não respeitada';
    case EventTrigger.LANE_DRIFT:
      return 'Mudança brusca de faixa';
    case EventTrigger.FRONT_COLLISION_WARNING:
    case EventTrigger.TAILGATING:
      return 'Distância insegura';
    case EventTrigger.ANOMALY:
      return 'Anomalia';
    case EventTrigger.DISTRACTED_DRIVING:
      return 'Direção distraída';
    case EventTrigger.YAWN:
      return 'Bocejo';
    case EventTrigger.EYES_CLOSED:
      return 'Olhos fechados';
    case EventTrigger.PHONE_USAGE:
      return 'Uso de celular';
    case EventTrigger.SMOKING:
      return 'Fumando ao volante';
    case EventTrigger.MAX_SPEED_EXCEEDED:
      return 'Velocidade máxima excedida';
    case EventTrigger.SOS:
      return 'Botão do motorista';
    default:
      return 'Desconhecido';
  }
};

export const getMediaEventBadge = (eventTrigger: EventTrigger) => {
  switch (eventTrigger) {
    case EventTrigger.COLLISION:
      return <TagFeatures.Beta variant='outlined' label='Beta' />;
    default:
      return;
  }
};

export const SeverityTag: React.FC<SeverityTagProps> = React.memo(({ severity }: SeverityTagProps) => {
  switch (severity) {
    case Severity.MEDIUM:
      return (
        <div className={styles.eventTriggerTag}>
          <TagGravity.Moderate variant='surface' label='Moderada' size='sm' />
        </div>
      );
      break;
    case Severity.SEVERE:
      return (
        <div className={styles.eventTriggerTag}>
          <TagGravity.Severe variant='surface' label='Grave' size='sm' />
        </div>
      );
      break;
    case Severity.VERY_SEVERE:
      return (
        <div className={styles.eventTriggerTag}>
          <TagGravity.Gravest variant='surface' label='Gravíssima' size='sm' />
        </div>
      );
      break;
    default:
      return (
        <div className={styles.eventTriggerTag}>
          <TagGravity.Moderate variant='surface' label='Desconhecida' size='sm' />
        </div>
      );
      break;
  }
});
